"use client";

import { LegalDocument } from "@/components/marketing/LegalDocument";

export default function PrivacyPage() {
  return (
    <LegalDocument
      titleKey="legal.privacyTitle"
      introKey="legal.privacyIntro"
      contactKey="legal.privacyContact"
      sections={[
        { headingKey: "legal.privacyS1Heading", bodyKey: "legal.privacyS1Body" },
        { headingKey: "legal.privacyS2Heading", bodyKey: "legal.privacyS2Body" },
        { headingKey: "legal.privacyS3Heading", bodyKey: "legal.privacyS3Body" },
        { headingKey: "legal.privacyS4Heading", bodyKey: "legal.privacyS4Body" },
        { headingKey: "legal.privacyS5Heading", bodyKey: "legal.privacyS5Body" },
        { headingKey: "legal.privacyS6Heading", bodyKey: "legal.privacyS6Body" },
        { headingKey: "legal.privacyS7Heading", bodyKey: "legal.privacyS7Body" },
      ]}
    />
  );
}
